// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentsByMarketQueryVariables = Types.Exact<{
  market: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type DevelopmentsByMarketQuery = { __typename?: 'Query', developments: Array<{ __typename?: 'Development', id: string, name: string }> };


export const DevelopmentsByMarketDocument = gql`
    query DevelopmentsByMarket($market: [ID!]!) {
  developments(filter: {market: $market}) {
    id
    name
  }
}
    `;

/**
 * __useDevelopmentsByMarketQuery__
 *
 * To run a query within a React component, call `useDevelopmentsByMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentsByMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentsByMarketQuery({
 *   variables: {
 *      market: // value for 'market'
 *   },
 * });
 */
export function useDevelopmentsByMarketQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentsByMarketQuery, DevelopmentsByMarketQueryVariables> & ({ variables: DevelopmentsByMarketQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentsByMarketQuery, DevelopmentsByMarketQueryVariables>(DevelopmentsByMarketDocument, options);
      }
export function useDevelopmentsByMarketLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentsByMarketQuery, DevelopmentsByMarketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentsByMarketQuery, DevelopmentsByMarketQueryVariables>(DevelopmentsByMarketDocument, options);
        }
export function useDevelopmentsByMarketSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentsByMarketQuery, DevelopmentsByMarketQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentsByMarketQuery, DevelopmentsByMarketQueryVariables>(DevelopmentsByMarketDocument, options);
        }
export type DevelopmentsByMarketQueryHookResult = ReturnType<typeof useDevelopmentsByMarketQuery>;
export type DevelopmentsByMarketLazyQueryHookResult = ReturnType<typeof useDevelopmentsByMarketLazyQuery>;
export type DevelopmentsByMarketSuspenseQueryHookResult = ReturnType<typeof useDevelopmentsByMarketSuspenseQuery>;
export type DevelopmentsByMarketQueryResult = Apollo.QueryResult<DevelopmentsByMarketQuery, DevelopmentsByMarketQueryVariables>;